import { generateBaseQueryKeysList } from '@/queries/utils';

export const HUBS_KEYS = {
  main: 'hubs',
};

export const hubsQueryKeys = generateBaseQueryKeysList(HUBS_KEYS.main);
